import { useEffect, useState, useCallback } from "react";
import * as S from "./styles";

import { ReactComponent as Logo } from "assets/logo.svg";
import { ReactComponent as Payments } from "assets/SidebarIcons/payments.svg";

import ExitIcon from "assets/SidebarIcons/logout.svg";

import { useLocation, useHistory } from "react-router-dom";
import { useAuth } from "contexts/authContext";
import { sidebarRoutes } from "./data";

export function SideBar() {
  const { setIsAuthenticated, isFinancial, config } = useAuth();

  const [path, setPath] = useState("");

  const restricted = [isFinancial ? null : `financial`];

  const location = useLocation();
  const history = useHistory();

  const redirectToHome = useCallback(() => {
    history.push("home");
  }, [history]);

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);
  return (
    <S.Nav data-cy="sidebar">
      <S.Logo onClick={redirectToHome}>
        <img
          src={config && config.imgURL ? config.imgURL : <Logo />}
          alt="Logo"
        />
      </S.Logo>
      <S.Container>
        <S.LinksContainer>
          {sidebarRoutes
            .filter(
              (el) => !(el.restrictedTo && restricted.includes(el.restrictedTo))
            )
            .map((route) => (
              <S.StyledLink
                key={route.location}
                to={route.location}
                data-for="main"
                data-tip={route.tooltipLabel}
                data-iscapture="true"
                isSelected={path === route.location}
              >
                <S.Links>
                  <S.SideBarIconSelected isSelected={path === route.location}>
                    {route.icon}
                  </S.SideBarIconSelected>
                </S.Links>
              </S.StyledLink>
            ))}

            {isFinancial && (
              <S.StyledLink
                to="/payments"
                data-for="main"
                data-tip={'Pagamentos'}
                data-iscapture="true"
                isSelected={path === "/payments"}
              >
                <S.Links>
                  <S.SideBarIconSelected isSelected={path === "/payments"}>
                    <Payments />
                  </S.SideBarIconSelected>
                </S.Links>
              </S.StyledLink>
            )}
        </S.LinksContainer>

        <S.NavLink
          href="/"
          data-for="main"
          data-tip="Desconectar"
          data-iscapture="true"
          onClick={() => {
            setIsAuthenticated(false);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("config");
          }}
        >
          <img src={ExitIcon} alt="Sair" data-cy="logout-btn" />
        </S.NavLink>

        <S.StyledReactTooltip
          id="main"
          place="right"
          type="dark"
          effect="solid"
          backgroundColor={"var(--black-400)"}
        />
      </S.Container>
    </S.Nav>
  );
}
